var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 512 512",
    id: "Layer_1",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.4,253c1.9-58.7,19.7-109.4,55.2-153.4c41.6-51.7,95.6-82.9,161.5-91.2c76.6-9.6,144.2,12.2,200.7,64.8   c50.1,46.6,76.5,104.9,79.2,173.3c2.9,74-22.2,137.6-74.6,189.8c-40.2,40.1-89.1,63.7-145.8,69.6c-79.3,8.2-147.7-16.2-203.9-72.4   c-41.6-41.6-64.8-92.5-71-151.1C6.7,272,6.4,261.3,6.4,253z M254.6,488.2c124.4,0.5,228.1-100.7,229.4-228.6   c1.3-130.3-102.8-232.7-226.7-233.8c-125.7-1.1-230.3,100.7-231,228.9C25.4,384.4,127.6,488.2,254.6,488.2z",
    fill: "#0478B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.7,233.6c1.4,0.3,1.8-0.7,2.4-1.5c15.3-22.5,37.2-29.7,63.1-26.5c31,3.8,50.8,23.8,57.6,56.5   c1.5,7.2,2.2,14.5,2.2,21.8c0.1,34.8,0,69.6,0.1,104.5c0,3.4-0.8,4.6-4.4,4.5c-15.7-0.2-31.3-0.2-47,0c-3.9,0.1-4.7-1.2-4.7-4.8   c0.1-32,0.1-64,0-96c0-6.2-0.5-12.2-2.6-18.2c-3.2-9.1-9.4-14.9-18.3-18.3c-24-9.1-47.8,6.3-48.1,31.9c-0.4,32.2-0.1,64.3-0.1,96.5   c0,8.8,0,8.8-9.1,8.8c-14,0-28-0.1-42,0.1c-3.6,0-4.9-0.7-4.9-4.6c0.2-57.5,0.1-115,0.1-172.4c0-3,0.7-4,3.9-4c16,0.2,32,0.1,48,0   c3.1,0,4.1,0.9,3.9,4C273.5,221.7,273.7,227.7,273.7,233.6z",
    fill: "#0478B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.6,303c0-28.2,0.1-56.3-0.1-84.5c0-4.8,1.5-5.8,5.9-5.7c15,0.3,30,0.2,45,0c3.6,0,4.9,0.8,4.9,4.7   c-0.1,57-0.1,114,0,171c0,3.6-1.2,4.4-4.6,4.4c-15.5-0.2-31-0.2-46.5,0c-3.9,0.1-4.6-1.4-4.6-4.9   C127.7,359.7,127.6,331.3,127.6,303z",
    fill: "#0478B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.8,148.6c0.2-16.5,12.1-27.8,29.3-27.7c16.7,0.2,28.3,12.2,28,29c-0.3,16.1-12.5,27.7-29.1,27.6   C137.4,177.5,125.7,165.4,125.8,148.6z",
    fill: "#0478B5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/linked_in.e8fb0d8ab8d2b966583b3a886c644ff9.svg";
export { ForwardRef as ReactComponent };